import { Model as e } from "../../../../../model.js";
class p extends e {
  constructor(s) {
    super(), this.pay = s.pay, this.paymentMethods = s.paymentMethods;
  }
}
export {
  p as ShopSessionAccessModel
};
//# sourceMappingURL=shopSessionAccess.model.js.map
